import { notification } from "antd";
import { apiPost } from "../../services/apiInterceptor";
import {
  PARTAGE_FORM_FAILURE,
  PARTAGE_FORM_REQUEST,
  PARTAGE_FORM_SUCCESS,
} from "../Types";

export const partageFormulaire = (partageData) => {
  return async (dispatch) => {
    dispatch({ type: PARTAGE_FORM_REQUEST });

    try {
      // ✅ MIGRATION : Plus besoin de gérer manuellement le token
      const response = await apiPost("api/forms/share/email", partageData);

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.message || "Erreur lors du partage du formulaire"
        );
      }

      dispatch({ type: PARTAGE_FORM_SUCCESS, payload: data });

      notification.success({
        message: data?.message || "Formulaire partagé avec succès",
        duration: 5,
      });

      return data;
    } catch (error) {
      dispatch({ type: PARTAGE_FORM_FAILURE, payload: error?.message });

      notification.error({
        message: error?.message || "Erreur lors du partage du formulaire",
        duration: 5,
      });
    }
  };
};
